export enum PATHS {
  splash_screen = 'SPLASH_SCREEN',
  login = '/login',
  forgot_password = '/forgot-password',
  confirm_email = '/confirm-email',
  create_password = '/password-set',
  recovery_password = '/password-reset',
  restore = '/restore',
  select_provider = '/select-provider',
  edit = 'EDIT',
  main = '/',
  availability = '/availability',
  users = '/users',
  settings = '/settings',
  // ТЗ 0093: «Обучение» (курсы, группы, журналы и их карточки) переехало с
  // `/settings` на `/education` — на `/settings` теперь хаб настроек. Ключи
  // `settings*` прежние: ссылки везде идут через PATHS, поменялись только
  // значения. Старые адреса — постоянные редиректы (`LEGACY_PATHS` ниже).
  education = '/education',
  settingsCourses = '/education/courses',
  // ТЗ 0040. Карточка курса: программа и навыки в одном месте. До неё «чему
  // учит курс» правилось в карьерном центре, а у самого курса не было и
  // перехода — таблица из трёх колонок без ссылки.
  settingsCourseDetail = '/education/courses/:courseId',
  settingsGroups = '/education/groups',
  settingsJournals = '/education/journals',
  // ТЗ 0074 (доработка): настройки приостановки доступа к LMS — робот, порог,
  // шаблоны SendGrid, Slack. Видна PAYMENT_ACCESS_ROLES. ТЗ 0093: раздел хаба
  // «Робот блокировки должников», адрес прежний.
  settingsLmsAccess = '/settings/lms-access',
  // ТЗ 0093: разделы хаба настроек. Вкладка — в адресе: `/settings/sms?tab=plans`,
  // `/settings/templates?topic=<тема>&template=<код>`,
  // `/settings/integrations?tab=kommo|slack|zoom`. Ссылки — только
  // построителями из `core/hooks/Settings/settingsLinks.ts`.
  settingsSms = '/settings/sms',
  settingsTemplates = '/settings/templates',
  settingsIntegrations = '/settings/integrations',
  // ТЗ 0093 этап 2а: правила писем дофинансирования (бывшая вкладка
  // `/dofinansowanie?tab=mailRules` — её уводит сама страница дофина).
  settingsDofinMail = '/settings/dofin-mail',
  // ТЗ 0093 этап 2а: справочники маркетинга `?tab=channels|courses|signals|
  // pipelines` (бывшая вкладка `/marketing?tab=settings&settab=…` — её уводит
  // сама страница маркетинга; источники, план и журнал выгрузки остались
  // там, вкладкой «Источники и план»).
  settingsMarketing = '/settings/marketing',
  // ТЗ 0093 этап 2а: правила и параметры cash flow (бывший блок вкладки
  // `/finances/cashflow?tab=control`, сама вкладка — сверки — осталась) и
  // параметры платёжного календаря (из его ящика настроек) —
  // `?tab=cashflow|calendar`.
  settingsFinance = '/settings/finance',
  // ТЗ 0093 этап 2а: тексты постов для репоста (бывшая подвкладка «Тексты
  // постов» вкладки «Акции» карьерного центра — адреса у неё не было).
  settingsCareer = '/settings/career',
  // ТЗ 0093 этап 2б: runtime-настройки — выключатели роботов, каналов,
  // почты, интеграций и пороги по вкладкам разделов сервера, таблица
  // периодических задач и журнал изменений (`?tab=<раздел>|schedules|
  // changes`); модели и платные ИИ-функции. Ссылки — построителями
  // `robotsSettingsHref` / `aiSettingsHref`.
  settingsRobots = '/settings/robots',
  settingsAi = '/settings/ai',
  profile = '/profile',
  no_shops = '/no-shops',
  dashboard = '/dashboard',
  communicator = '/communicator',
  debtors = '/debtors',
  contributions = '/debtors/contributions',
  // ТЗ 0074: «Wstrzymany dostęp» — LMS access suspensions (PAYMENT_ACCESS_ROLES).
  debtorsSuspended = '/debtors/suspended',
  debtorsPandadoc = '/debtors/pandadoc',
  debtorsPandadocProvisioning = '/debtors/pandadoc/provisioning',
  debtorsPandadocProvisioningFolder = '/debtors/pandadoc/provisioning/:folderUuid',
  journal = '/journal',
  finances = '/finances',
  financesDashboard = '/finances/dashboard',
  financesInvoices = '/finances/invoices',
  financesInvoice = '/finances/invoices/:id',
  financesExpenses = '/finances/expenses',
  financesExpense = '/finances/expenses/:id',
  financesExpenseNew = '/finances/expenses/new',
  financesPaymentCalendar = '/finances/calendar',
  financesCashFlow = '/finances/cashflow',
  // ТЗ 0075: выгрузка данных для P&L.
  financesPnl = '/finances/pnl',
  monitoring = '/monitoring',
  default = '/debtors',
  students = '/students',
  studentDetail = '/students/:id/details',
  teachers = '/teachers',
  teacherDetail = '/teachers/:id/details',
  groupDetail = '/education/groups/:id/details',
  teachersUsers = '/teachers/users',
  teachersApplications = '/teachers/applications',
  performance = '/performance',
  zoom = '/zoom',
  zoomDashboard = '/zoom/dashboard',
  zoomLessons = '/zoom/lessons',
  zoomLesson = '/zoom/lessons/:id',
  zoomRecordings = '/zoom/recordings',
  zoomRecording = '/zoom/recordings/:id',
  zoomMatching = '/zoom/matching',
  zoomRecent = '/zoom/recent',
  zoomSchedule = '/zoom/schedule',
  zoomAudit = '/zoom/audit',
  mcpAccess = '/mcp-access',
  whiteboardLesson = '/whiteboard/lesson/:id',
  surveys = '/surveys',
  surveyNew = '/surveys/new',
  surveyTeachers = '/surveys/teachers',
  surveyAnalytics = '/surveys/analytics',
  surveyTags = '/surveys/tags',
  surveySummary = '/surveys/:id/summary',
  surveyEdit = '/surveys/:id',
  surveyResults = '/surveys/assignments/:assignmentId/results',
  careerCenter = '/career-center',
  // ТЗ 0040 фаза B. Справочник анкет: создаются здесь, прикрепляются к урокам
  // из карточки урока. Отдельный адрес, а не вкладка, — анкету заводят до
  // того, как у неё появится урок.
  careerExercises = '/dictionaries/exercises',
  // ТЗ 0040 доводка: справочник навыков и карьерные уроки переехали из вкладок
  // на свои адреса. Все шесть справочников теперь в одном доме, с общей
  // полосой переходов и одним пунктом меню.
  careerSkills = '/dictionaries/skills',
  careerLessons = '/dictionaries/lessons',
  // ТЗ 0040 фаза C. Справочники, которые до сих пор правились только в
  // Django-админке и сидами.
  careerProfessions = '/dictionaries/professions',
  careerMedals = '/dictionaries/medals',
  careerSiteCourses = '/dictionaries/site-courses',
  dofinansowanie = '/dofinansowanie',
  // ТЗ 0076: договоры с подписанием через Documenso. Ящики — в адресе:
  // `?contract=<id>`, `?contractNew=1[&group=<id>][&fromLead=<id лида>]`
  // (ТЗ 0090: форма из карточки лида), `?contractEdit=<id>`.
  contracts = '/contracts',
  // ТЗ 0080: короткие ссылки (ручные + ссылки на подпись). Карточка — в
  // адресе: `?link=<id>`.
  shortLinks = '/short-links',
  // ТЗ 0081: SMS студентам. ТЗ 0093: здесь остался только журнал — фильтры в
  // адресе (`?student=<id>&status=…`); настройки, лесенки и шаблоны уехали в
  // хаб, старые `?tab=settings|plans|templates` уводит туда сама страница.
  sms = '/sms',
  // ТЗ 0084: лиды Kommo (воронка «New leads»). Карточка — в адресе:
  // `?lead=<id>`; фильтры — `?stage=&resp=&q=&closed=1&page=`. ТЗ 0093:
  // вкладка Admin «Kommo» уехала в «Настройки → Интеграции»; старый
  // `?tab=kommo` уводит туда сама страница.
  leads = '/leads',
  // ТЗ 0088: маркетинговая система. Вкладка, период, фильтры и спуск по
  // разрезам — в адресе: `?tab=channels&period=90d&ch=META&path=META,123`.
  marketing = '/marketing',
  // Публичный URL: обрабатывается ДО гейта авторизации в RootRouter.
}

/**
 * ТЗ 0093: адреса, которых больше нет. На них ведут закладки и ссылки,
 * вшитые в задачи и уведомления в БД, поэтому каждый — постоянный редирект
 * (`AppRouter`). Ссылок на них в коде быть не должно: только редиректы.
 */
export const LEGACY_PATHS = {
  /** `/settings/courses|groups|journals[/…]` — «Обучение» до ТЗ 0093. */
  education: '/settings/:section(courses|groups|journals)',
  /**
   * ТЗ 0078 → 0093: справочник шаблонов договоров, SMS и писем. Шаблоны
   * договоров и тексты сообщений теперь — «Настройки → Шаблоны сообщений».
   */
  contractTemplates: '/contracts/templates',
  /**
   * ТЗ 0093: аккаунты Zoom — вкладка «Настройки → Интеграции → Zoom».
   * Расписание по группам (`/zoom/schedule`) осталось в разделе Zoom.
   */
  zoomAccounts: '/zoom/accounts',
} as const;

/**
 * Новый адрес для старого адреса «Обучения»: меняется только префикс, всё
 * остальное (`:id`, `/details`) сохраняется — `/settings/groups/5/details`
 * → `/education/groups/5/details`. Query и hash переносит сам редирект.
 */
export const legacyEducationPath = (pathname: string): string =>
  pathname.replace(/^\/settings\//, `${PATHS.education}/`);

export function getAuthPath(path: string = '') {
  return `${path}`;
}

export enum PATHS_PARAMS {
  contributionNum = ':contributionNum',
}
